module.exports = __webpack_public_path__ + "img/ico-exit-log-out-arrow.51f4101b.svg";